export const BASE_API = "https://handy-helper-server-site.vercel.app"

// export const BASE_API = "http://localhost:5000";
